import { combineReducers } from 'redux';
import user from './user';
import security from './security';
import errors from './errors';
import userRole from './userRole';
import viewAttachment from './viewAttachmentReducer';
import productCategory from './productCategory'
import product from './product';
import vehicleModel from './vehicleModel';
import brand from './brand';
import vehicle from './vehicle';
import travelOrder from './travelOrder';

export default combineReducers({
  security,
  user,
  errors,
  userRole,
  viewAttachment,
  productCategory,
  product,
  vehicleModel,
  brand,
  vehicle,
  travelOrder,
});
